import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=5f71f3fc&scoped=true"
import script from "./main-content.vue?vue&type=script&lang=js"
export * from "./main-content.vue?vue&type=script&lang=js"
import style0 from "./main-content.vue?vue&type=style&index=0&id=5f71f3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71f3fc",
  null
  
)

export default component.exports